function selectImageLayer(context, event) {
  // This may be highlight the selected image with an outline.
  // For VTK.js, it currently only supports a single image, so we have to
  // switch.
  // Todo
}

export default selectImageLayer
